import React from "react";
import Form from "react-bootstrap/Form";
import { useField } from "formik";

import "./FormGroup.css";

const Switch = (props) => {
  const [field, meta] = useField(props);

  return (
    <Form.Group
      controlId={props.name}
      className="f-group"
      data-tour={props.datatour}
    >
      <p>{props.title}</p>
      <Form.Check
        type="switch"
        name={props.name}
        key={props.name}
        label={props.desc}
        checked={meta.value}
        onChange={field.onChange}
      />
    </Form.Group>
  );
};

export default Switch;
